import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useNotifications } from "@/app/hook/use-notifications";
import { AlertProps } from "@/base/components/index";

export type RedirectWithMessageProps = {
  to: string;
  message: string;
  type?: AlertProps["type"];
};

/**
 * Redirects to `to` and shows `message` in the global MessageBoundary
 * (the alert strip under the header), so the user learns why the page
 * they asked for was replaced.
 */
export const RedirectWithMessage = ({
  to,
  message,
  type = "error",
}: RedirectWithMessageProps) => {
  const notifications = useNotifications();

  useEffect(() => {
    notifications.show({ type, message });
    // Show once per mount: the message must not re-fire on notification updates.
  }, []);

  return <Navigate to={to} replace />;
};
